var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTransactions = function SvgTransactions(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4246 1.575L15.8496 0L14.2746 1.575L12.6996 0L11.1246 1.575L9.54961 0L7.97461 1.575L6.39961 0L4.82461 1.575L3.24961 0V14.7H0.0996094V17.85C0.0996094 19.593 1.50661 21 3.24961 21H15.8496C17.5926 21 18.9996 19.593 18.9996 17.85V0L17.4246 1.575ZM12.6996 18.9H3.24961C2.67211 18.9 2.19961 18.4275 2.19961 17.85V16.8H12.6996V18.9ZM16.8996 17.85C16.8996 18.4275 16.4271 18.9 15.8496 18.9C15.2721 18.9 14.7996 18.4275 14.7996 17.85V14.7H5.34961V3.15H16.8996V17.85Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7004 5.24805H6.40039V7.34805H12.7004V5.24805Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.852 5.24805H13.752V7.34805H15.852V5.24805Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7004 8.39844H6.40039V10.4984H12.7004V8.39844Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.852 8.39844H13.752V10.4984H15.852V8.39844Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTransactions);
export default ForwardRef;